import React from 'react';
import { Typography } from '@material-ui/core';
import { FieldTypeIcon } from '../../../../internal-components/form-builder/FormBuilderFieldForm';
import SelectEngine from '../../../engine/SelectEngine';
import { SimpleFlexContainer } from '../../../layouts/ng-layouts/Containers';
import { TextString } from '../../../Text';
import TextFieldEngine from '../../../form/engine/TextFieldEngine';
import {
  compareTypeMap,
  conditionDisabled
} from '../../../../internal-components/conditional-logic/compareTypeMap';
import { FieldTypes } from '../../../form/view/FieldView';
import styled from 'styled-components/macro';

const FieldSelectionContainer = styled(SimpleFlexContainer)`
  height: 3rem;
  margin-right: 1rem;
`;

const ValueSelectionContainer = styled(SimpleFlexContainer)`
  align-self: center;
`;

const getTypedFieldEngine = uiType => {
  return FieldTypes[uiType] || TextFieldEngine;
};

const ChangeValueView = props => {
  const uiType = props.field2Update ? props.field2Update.uiType : null;
  const valueOptions = props.field2Update ? props.field2Update.options : [];
  const defaultCountry = props.field2Update
    ? props.field2Update.defaultCountry
    : '';
  const compareType = compareTypeMap[uiType];
  const TypedFieldEngine = getTypedFieldEngine(uiType);
  return (
    <>
      <FieldSelectionContainer $row>
        <SelectEngine
          variant={props.variant}
          customCSS="margin-left: 0.8rem !important;"
          searchable
          virtualize
          virtualiziztionProps={{ itemSize: 60, width: '100%' }}
          data-testid={`select-field`}
          value={props.fieldId2Update}
          onChange={props.setFieldId2Update}
          placeholder="Choose a question"
          options={props.formFields.map(
            ({ internalId: id, uiType, title, lookupInfo }) => ({
              value: id,
              'data-testid': `logicbuilder-condition-select-field-value-${id}`,
              text: title || `Untitled ${uiType} field`,
              uiType,
              disabled: conditionDisabled.includes(uiType),
              isSubField: lookupInfo && lookupInfo.subFieldInfo
            })
          )}
          openMenuOptionParser={opt => {
            return (
              <>
                <FieldTypeIcon fieldType={opt.uiType} />
                <span
                  style={{
                    maxWidth: 400,
                    display: 'inline-block',
                    whiteSpace: 'normal',
                    width: 'calc(100% - 64px)',
                    alignSelf:
                      opt.text && opt.text.length > 50 ? 'baseline' : 'auto'
                  }}
                >
                  <Typography>
                    <TextString content={opt.text} />
                  </Typography>
                </span>
              </>
            );
          }}
        />
      </FieldSelectionContainer>
      <ValueSelectionContainer $row>
        {!uiType ? (
          ''
        ) : (
          <TypedFieldEngine
            data-testid={uiType + '-field-value'}
            defaultCountry={defaultCountry}
            setValue={
              compareType === 'number'
                ? props.setNumericValue
                : props.setFieldValue
            }
            options={valueOptions}
            uiType={uiType}
            value={props.fieldValue}
          />
        )}
      </ValueSelectionContainer>
    </>
  );
};

export default ChangeValueView;
